import { cn } from "@/common/helpers/utils";
import { Input } from "@/components/ui/input";
import { MoveRightIcon } from "lucide-react";

export interface NumberRangeInputProps {
  min: string;
  max: string;
  onMinChange: (value: string) => void;
  onMaxChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

export function NumberRangeInput({ min, max, onMinChange, onMaxChange, disabled, className }: NumberRangeInputProps) {
  return (
    <div className={cn("flex items-center gap-1.5", className)}>
      <Input
        type="number"
        value={min}
        onChange={(e) => onMinChange(e.target.value)}
        placeholder="Min."
        disabled={disabled}
        className="min-w-0"
        min={0}
      />
      <MoveRightIcon className="text-muted-foreground size-4 shrink-0" aria-hidden="true" />
      <Input
        type="number"
        value={max}
        onChange={(e) => onMaxChange(e.target.value)}
        placeholder="Max."
        disabled={disabled}
        className="min-w-0"
        min={0}
      />
    </div>
  );
}
